export default __webpack_public_path__ + "static/media/xd.5cf7f30dbee57100813f557b66f2209b.svg";